import React from 'react';

const SVG = ({width = '16px', height = '16px', title = 'Info'}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 29.94 29.94"
    className="bi bi-info-outline"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>{title}</title>
    <g>
      <path
        fillRule="evenodd"
        d="M15,7.48a1.87,1.87,0,1,0,1.87,1.87A1.87,1.87,0,0,0,15,7.48Zm0,5.61A1.87,1.87,0,0,0,13.1,15v5.61a1.87,1.87,0,0,0,3.74,0V15A1.87,1.87,0,0,0,15,13.1ZM15,0a15,15,0,1,0,15,15A15,15,0,0,0,15,0Zm0,27.13A12.16,12.16,0,1,1,27.13,15,12.18,12.18,0,0,1,15,27.13Z"
      />
    </g>
  </svg>
);

export default SVG;
